
  import "./Frome.css"
const Frome =()=>{

    return (
        <>
        <div className="div">
            <label>Full Name</label>
            <input type="text"  placeholder="Full Name"/>
        </div>
        <div className="div">
            <label>Email Address</label>
            <input type="text"  placeholder="Email Address"/>
        </div>
        <div className="div">
            <label>Company</label>
            <input type="text" placeholder="Company"/>
        </div>
        <div className="div">
            <label>Website URL</label>
            <input type="text" placeholder="Website URL"/>
        </div>
        <div className="div">
            <label>Password</label>
            <input type="text" placeholder="Password"/>
        </div>
        </>
    )

}

export default Frome